@if (
  {
    count: count(),
    title: title(),
    layoutType: layoutType(),
    filterName: filterName(),
    allowSearchInput: allowSearchInput(),
    searchPlaceholder: searchPlaceholder(),
    defaultSearchText: defaultSearchText(),
    allowAddButton: allowAddButton(),
    addIcon: addIcon(),
    addButtonLabel: addButtonLabel(),
    isListFilterVisible: isListFilterVisible()
  };
  as STATE
) {
  <article class="search-bar">
    <header *ngIf="STATE.title" class="search-bar__header">
      <h3 class="search-bar__title">{{ STATE.title }}</h3>
    </header>

    <section class="search-bar__actions">
      <div class="search-bar__actions__filter">
        <button
          *ngIf="STATE.layoutType"
          (click)="switchLayoutType()"
          class="search-bar__actions__filter"
        >
          <img
            [lazyLoad]="
              STATE.layoutType === 'list'
                ? 'assets/icons/grid.svg'
                : 'assets/icons/list.svg'
            "
            alt="Changer la disposition (grille ou liste)"
          />
        </button>
        <ng-container *ngIf="STATE.filterName && listFilters?.length">
          <button
            (click)="toggleFilterSheet()"
            class="search-bar__actions__filter-button"
            matTooltip="Appliquez des filtres par période"
            matTooltipPosition="above"
          >
            <mat-icon svgIcon="dgi-filter" color="primary"></mat-icon>
            <span *ngIf="appliedFilterCount">{{ appliedFilterCount }}</span>
          </button>
        </ng-container>
      </div>

      <div
        *ngIf="STATE.allowSearchInput"
        matTooltip="Recherchez une facture, un reçu, un partenaire ou un article"
        matTooltipPosition="above"
      >
        <search-bar-input
          (search)="searchClicked($event)"
          [placeholder]="STATE.searchPlaceholder!"
          [defaultValue]="STATE.defaultSearchText"
          [autoCompleteFn]="searchAutoCompleteFn"
        ></search-bar-input>
      </div>

      <section class="search-bar__actions__buttons">
        <ng-content></ng-content>

        <ng-container *ngIf="STATE.allowAddButton">
          <button
            type="button"
            button
            [variant]="'primaryLight'"
            size="md"
            (click)="addClicked()"
            class="search-bar__actions__buttons--add"
          >
            <mat-icon
              [svgIcon]="'dgi-' + STATE.addIcon"
              color="primary"
            ></mat-icon>
            {{ STATE.addButtonLabel }}
          </button>
        </ng-container>
      </section>
    </section>
  </article>

  <section
    [class.tab-filters--collapsed]="!STATE.isListFilterVisible"
    class="tab-filters"
  >
    <div class="tab-filters__inputs-wrapper">
      <ng-container *ngFor="let filter of listFilters; trackBy: trackByFilter">
        <ng-container [ngSwitch]="filter.inputType">
          <article *ngSwitchCase="'select'">
            <!-- <mat-label>{{ filter.displayedName }}</mat-label>
            <mat-form-field class="border-less w-full">
              <mat-select
                (selectionChange)="
                  setFilterValue(filter.requestKey, $event.value)
                "
                [placeholder]="
                  filter.displayedPlaceholder || filter.displayedName
                "
              >
                <mat-option
                  class="mat-mdc-select-value--placeholder"
                  [value]="null"
                  >Tout</mat-option
                >
                <mat-option
                  *ngFor="
                    let option of filter.selectValues$ | async;
                    trackBy: trackByOption
                  "
                  [value]="option.value"
                >
                  {{ option.name }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->
            <label [for]="filter.requestKey" class="form__label">
              {{ filter.displayedName }}
            </label>
            <ng-select
              [labelForId]="filter.requestKey"
              appendTo="body"
              clearAllText="Effacer"
              (change)="setFilterValue(filter.requestKey, $event)"
              [placeholder]="
                filter.displayedPlaceholder || 'Sélectionner une valeur'
              "
            >
              <ng-option [value]="null">Tout</ng-option>
              <ng-option
                *ngFor="
                  let option of (filter.selectValues$ | async) || [];
                  trackBy: trackByOption
                "
                [value]="option.value"
              >
                {{ option.name }}
              </ng-option>
            </ng-select>
          </article>

          <article *ngSwitchCase="'multi-select'">
            <!-- <mat-label>{{ filter.displayedName }}</mat-label>
            <mat-form-field>
              <mat-select
                (selectionChange)="
                  setFilterValue(filter.requestKey, $event.value)
                "
                [placeholder]="
                  filter.displayedPlaceholder || filter.displayedName
                "
                [multiple]="true"
              >
                <mat-option
                  *ngFor="
                    let option of filter.selectValues$ | async;
                    trackBy: trackByOption
                  "
                  [value]="option.value"
                >
                  {{ option.name }}
                </mat-option>
              </mat-select>
            </mat-form-field> -->

            <label [for]="filter.requestKey" class="form__label">
              {{ filter.displayedName }}
            </label>
            <ng-select
              [labelForId]="filter.requestKey"
              appendTo="body"
              clearAllText="Effacer"
              [multiple]="true"
              (change)="setFilterValue(filter.requestKey, $event)"
              [placeholder]="
                filter.displayedPlaceholder || 'Sélectionner des valeurs'
              "
            >
              <ng-option [value]="null">Tout</ng-option>

              @if ({ values: filter.selectValues$ | async }; as selecState) {
                <ng-option
                  *ngFor="
                    let option of selecState.values;
                    trackBy: trackByOption
                  "
                  [value]="option.value"
                >
                  {{ option.name }}
                </ng-option>

                <ng-template ng-multi-label-tmp let-items="items">
                  @if (items.length === 1) {
                    {{
                      items[0] | useFunction: getLabelName : selecState.values
                    }}
                  } @else if (items.length > 1) {
                    {{
                      items[0] | useFunction: getLabelName : selecState.values
                    }}
                    (+{{ items.length - 1 }}
                    {{ items.length - 1 === 1 ? 'autre' : 'autres' }})
                  }
                </ng-template>
              }
            </ng-select>
          </article>

          <article *ngSwitchCase="'date'">
            <mat-label>{{ filter.displayedName }}</mat-label>
            <mat-form-field>
              <input
                (click)="picker.open()"
                (dateChange)="
                  selectDate(filter.requestKey, $event.target.value)
                "
                matInput
                [matDatepicker]="picker"
                readonly
              />
              <mat-datepicker-toggle
                #toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </article>

          <article *ngSwitchCase="'date-range'">
            <mat-label>{{ filter.displayedName }}</mat-label>
            <mat-form-field class="form-field__input">
              <mat-date-range-input #range [rangePicker]="picker">
                <input
                  #dateRangeStart
                  (click)="picker.open()"
                  matStartDate
                  [placeholder]="'Date de début'"
                  readonly
                />
                <input
                  #dateRangeEnd
                  (dateChange)="selectDateRange(filter.requestKey, range.value)"
                  (click)="picker.open()"
                  matEndDate
                  [placeholder]="'Date de fin'"
                  readonly
                />
              </mat-date-range-input>
              <mat-datepicker-toggle
                matPrefix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </article>

          <article *ngSwitchCase="'autocomplete'">
            <mat-label>{{ filter.displayedName }}</mat-label>
            <mat-form-field>
              <input
                type="text"
                #input
                [id]="'search-bar-autocomplete-' + filter.requestKey"
                matInput
                [matAutocomplete]="auto"
                [placeholder]="
                  filter.displayedPlaceholder || filter.displayedName
                "
                (input)="onInputChange(filter, input)"
              />
              @if (input.value) {
                <button
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  class="autocomplete-clear-btn"
                  (click)="clearFilter(filter, input)"
                >
                  <mat-icon svgIcon="dgi-cancel" color="primary"></mat-icon>
                </button>
              }

              <mat-autocomplete
                [autoActiveFirstOption]="false"
                [displayWith]="selectOptionDisplayFn"
                #auto="matAutocomplete"
                (optionSelected)="
                  setFilterValue(filter.requestKey, $event.option.value.value)
                "
              >
                @if (!!filter.autocompleteValues$) {
                  @for (
                    option of input.value
                      | useFunction: filter.autocompleteValues$
                      | async;
                    track $index;
                    let first = $first
                  ) {
                    @if (first) {
                      <mat-option
                        [value]="{
                          name: '',
                          value: null
                        }"
                        >Tout</mat-option
                      >
                    }
                    <mat-option [value]="option">
                      <div class="mat-option__title">
                        {{ option.name }}
                      </div>
                    </mat-option>
                  }
                  <!---->
                  @empty {
                    @if (input.value.trim()) {
                      <mat-option disabled>Aucun résultat</mat-option>
                    }
                  }
                }
              </mat-autocomplete>
            </mat-form-field>
          </article>

          <article *ngSwitchDefault class="form__group">
            <mat-label>{{ filter.displayedName }}</mat-label>
            <mat-form-field>
              <input
                type="text"
                #input
                [id]="filter.requestKey"
                matInput
                [placeholder]="
                  filter.displayedPlaceholder || filter.displayedName
                "
                (change)="setFilterValue(filter.requestKey, input.value)"
              />
              @if (input.value && input.value.trim() !== filter.requestValue) {
                <button
                  (click)="setFilterValue(filter.requestKey, input.value)"
                  mat-icon-button
                  matSuffix
                  class="enter-button"
                >
                  <mat-icon svgIcon="dgi-keyboard-return"></mat-icon>
                </button>
              }
              @if (input.value && input.value.trim() === filter.requestValue) {
                <button
                  (click)="input.value = ''"
                  mat-icon-button
                  matSuffix
                  class="close-button"
                >
                  <mat-icon svgIcon="dgi-cancel"></mat-icon>
                </button>
              }
            </mat-form-field>
          </article>
        </ng-container>
      </ng-container>

      <section class="tab-filters__action-button">
        <button
          *ngIf="!!appliedFilterCount"
          color="primary"
          class="tab-filters__clear"
          (click)="clearListFilterValues()"
        >
          Tout effacer
        </button>
      </section>
    </div>
  </section>
}
